import React, { useEffect, Fragment } from 'react'
import Header from './common/Header';
import Footer from './common/Footer';
import SEO from '../components/common/SEO';

function Feedback() {
  return (
    <div>
      <Fragment>
              <SEO title="Feedback | Mangoloops" description="We value your feedback. Share your thoughts, suggestions, or issues with Mangoloops to help us improve our services." />
              <Header />
             <section className="feedback-section py-5" style={{ paddingTop: '120px' }}>
    <div className="container">
        <div className="row">
            <div className="col-12">
                <div class="text-center mb-5">
                    <h2 class="section-title">We Value Your Feedback</h2>
                    <p class="lead text-muted">
                        Help us improve our services by sharing your thoughts, suggestions, or any issues you encountered.
                        Your feedback is important to us!
                    </p>
                </div>

                <div class="card shadow-sm">
                    <div class="card-body p-4 p-md-5">
                        <form id="feedbackForm">
                            {/* <!-- Name --> */}
                            <div class="mb-4">
                                <label for="feedbackName" class="form-label">Full Name <span class="text-danger">*</span></label>
                                <input type="text" class="form-control form-control-lg" id="feedbackName" name="name" placeholder="Enter your full name" required />
                                <div class="invalid-feedback">
                                    Please enter your name.
                                </div>
                            </div>

                            {/* <!-- Email --> */}
                            <div class="mb-4">
                                <label for="feedbackEmail" class="form-label">Email Address <span class="text-danger">*</span></label>
                                <input type="email" class="form-control form-control-lg" id="feedbackEmail" name="email" placeholder="you@example.com" required />
                                <div class="invalid-feedback">
                                    Please enter a valid email address.
                                </div>
                            </div>

                            {/* <!-- Subject --> */}
                            <div class="mb-4">
                                <label for="feedbackSubject" class="form-label">Subject</label>
                                <input type="text" class="form-control form-control-lg" id="feedbackSubject" name="subject" placeholder="e.g., Suggestion for Hotel Booking" />
                            </div>

                            {/* <!-- Feedback Type --> */}
                            <div class="mb-4">
                                <label for="feedbackType" class="form-label">Feedback Type <span class="text-danger">*</span></label>
                                <select class="form-select form-select-lg" id="feedbackType" name="type" required>
                                    <option value="" disabled selected>Select feedback type...</option>
                                    <option value="compliment">Compliment</option>
                                    <option value="suggestion">Suggestion</option>
                                    <option value="complaint">Complaint</option>
                                    <option value="bug_report">Bug Report</option>
                                    <option value="other">Other</option>
                                </select>
                                <div class="invalid-feedback">
                                    Please select a feedback type.
                                </div>
                            </div>

                            {/* <!-- Message --> */}
                            <div class="mb-4">
                                <label for="feedbackMessage" class="form-label">Your Feedback <span class="text-danger">*</span></label>
                                <textarea class="form-control form-control-lg" id="feedbackMessage" name="message" rows="6" placeholder="Tell us more..." required></textarea>
                                <div class="invalid-feedback">
                                    Please provide your feedback message.
                                </div>
                            </div>

                            {/* <!-- Optional: Attach File --> */}
                            <div class="mb-4">
                                <label for="feedbackAttachment" class="form-label">Attach a file (Optional)</label>
                                <input class="form-control form-control-lg" type="file" id="feedbackAttachment" name="attachment" />
                                <small class="form-text text-muted">Max file size: 5MB. Allowed types: JPG, PNG, PDF.</small>
                            </div>

                            {/* <!-- Consent Checkbox --> */}
                            <div class="mb-4 form-check">
                                <input type="checkbox" class="form-check-input" id="feedbackConsent" name="consent" />
                                <label class="form-check-label" for="feedbackConsent">I agree to be contacted regarding this feedback if necessary.</label>
                            </div>

                            {/* <!-- Submit Button --> */}
                            <div class="d-grid">
                                <button type="submit" class="btn btn-primary btn-lg">Submit Feedback</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="mt-5 text-center">
                    <p class="text-muted">Alternatively, you can reach us directly at:</p>
                    <p>
                        <i class="fas fa-envelope me-2"></i> <a href="mailto:support@example.com">support@example.com</a>
                    </p>
                    <p>
                        <i class="fas fa-phone me-2"></i> <a href="tel:+1234567890">+1 (234) 567-890</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
              <Footer />
      </Fragment>
    </div>
  )
}

export default Feedback
